module.exports = __webpack_public_path__ + "static/img/1.2486b7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/1.png
// module id = DxKZ
// module chunks = 0